<div class="my-4 row col-12">
  <div class="button-tabs d-flex flex-row w-100">
    <ng-container *ngFor="let value of values; let i = index">
      <input type="button" class="tab-button" (click)="selectTab(i)" [value]="value" [ngClass]="state[i]">
    </ng-container>
  </div>
</div>
